
import Pop from "./blue-pop.vue";
import { Component, Vue } from "vue-property-decorator";

/**
 * 项目中所有能通过文字生成视频的地方，都添加一个提示信息，如何标音，比如：美的，让生成的视频读音为 美的[[di4]]
 */
@Component({
  components: {
    Pop
  }
})
export default class TtsConfigPop extends Vue {}
